<div class="ms-5 me-5 mt-5 w-100">
  <div class="row">
    <div class="col-12">
      <div class="mx-auto col-lg-6">
        <!-- Loading State -->
        <div *ngIf="isLoading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading configuration...</span>
          </div>
          <p class="mt-3 text-muted">Loading Journey configuration...</p>
        </div>
        <!-- Help Section -->
        <div class="row mt-3">
          <div class="bg-white rounded-1 p-3 col-12">
            <h6 class="mb-3 font-weight-bold">
              <i class="fas fa-info-circle me-2"></i>
              Configuration Guide
            </h6>
            <ul class="small text-muted mb-0">
              <li>
                <strong>Hide from User List:</strong> When enabled, Child
                applications created from this Journey will not appear in the
                user's main application tracking list, instead they will be
                viewed when user open the journey application.
              </li>
              <li>
                <strong>RFA on Parent:</strong> When enabled, Request for Action
                must be initiated on the parent application instead of the child
                application.
              </li>
              <li>
                <strong>Trigger Parent Mappings:</strong> Define which parent
                application event should be triggered when a child application
                reaches a specific state. For example: When BIRTH_CERTIFICATE
                reaches PENDING_RESUBMISSION state, trigger REQUEST_FOR_ACTION
                event on parent.
              </li>
            </ul>
          </div>
        </div>

        <!-- Configuration Form -->
        <div *ngIf="!isLoading">
          <!-- Toggle Header (Wizard/Code Editor Tabs) -->
          <div class="row my-3">
            <div class="col-12">
              <irembogov-service-request-header-togger-widget
                [options]="headerOptions"
                [selectedOption]="selectedOption"
                (selectOption)="
                  onSelectOptionChange($event)
                "></irembogov-service-request-header-togger-widget>
            </div>
          </div>

          <!-- Wizard Mode - UI Form -->
          <div
            *ngIf="
              selectedOption === EServiceChangeRequestToggleHeaders.WIZARD
            ">
            <div class="row mt-3">
              <div class="bg-white rounded-1 p-3 col-12">
                <h5 class="mb-4 font-weight-bold border-bottom-secondary">
                  Journey Configuration
                </h5>
                <p class="text-muted mb-4">
                  Configure trigger parent mappings and additional application
                  settings for Journey V3 services.
                </p>

                <form [formGroup]="form">
                  <formly-form
                    [form]="form"
                    [fields]="fields"
                    [model]="model"
                    [options]="options"></formly-form>
                </form>
              </div>
            </div>
          </div>

          <!-- Code Editor Mode - JSON Editor -->
          <ng-container
            jsoneditor
            *ngIf="
              selectedOption === EServiceChangeRequestToggleHeaders.CODE_EDITOR
            ">
            <div class="row mt-3">
              <div class="bg-white rounded-1 p-3 col-12">
                <h5 class="mb-4 font-weight-bold border-bottom-secondary">
                  Journey Configuration (JSON)
                </h5>
                <div class="form-group">
                  <div class="input-group mb-3">
                    <json-editor
                      [options]="editorOptions"
                      id="jsonJourneyData"
                      class="form-control p-0 json-form-data-field"
                      (change)="validateJsonEditor()"
                      (keyup)="validateJsonEditor()"
                      #jsonJourneyData>
                    </json-editor>
                  </div>
                  <div
                    class="form-error w-100 small text-danger"
                    *ngIf="jsonEditorValidationErrors.length > 0">
                    JSON input is invalid
                    <ol>
                      <li
                        class="w-100 small"
                        *ngFor="
                          let error of jsonEditorValidationErrors;
                          let index = index
                        ">
                        <em class="text-muted"> Line {{ error['line'] }}</em>
                        <br />
                        <small [innerHTML]="error['message']"></small>
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Action Buttons -->
          <div class="row">
            <div class="text-end mt-3 px-0">
              <button
                type="button"
                class="btn btn-primary mx-auto px-5"
                (click)="onSave()"
                [disabled]="
                  isSaving ||
                  (selectedOption ===
                    EServiceChangeRequestToggleHeaders.WIZARD &&
                    !form.valid) ||
                  (selectedOption ===
                    EServiceChangeRequestToggleHeaders.CODE_EDITOR &&
                    jsonEditorValidationErrors.length > 0)
                ">
                <span
                  *ngIf="isSaving"
                  class="spinner-border spinner-border-sm me-2"
                  role="status"></span>
                {{ isSaving ? 'Saving...' : 'Continue' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
